import { Theme } from "@material-ui/core"
import Grid from "@material-ui/core/Grid"
import makeStyles from "@material-ui/core/styles/makeStyles"
import FormControl from "@material-ui/core/FormControl"
import TextField from "@material-ui/core/TextField"
import InputLabel from "@material-ui/core/InputLabel"
import React, { Fragment, useContext } from "react"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import FieldSelect from "Components/Table/FieldSelect"
import { useUpdatedDraft } from "./hooks"
import { Board } from "Types/board"
import ChargePerson from "Components/Calendar/ChargePerson"
import { AppContext } from "Views/Home/context"
import Button from "@material-ui/core/Button"

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: "absolute",
        width: "100%",
        height: "100%",
    },
    timeBlock: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        marginTop: 20,
    },
    input: {
        width: "100%",
        marginTop: 10,
    },
    materialBtn: {
        display: "flex",
        justifyItems: "flex-start",
        alignItems: "center",
        marginTop: 20,
        marginLeft: -5,
    },
}))

const DraftUpdate = () => {
    const classes = useStyles()
    const {
        callback, cancelCallback,
        dialogData, disabled, isBusiness, isMine,
        text, handleChange,
        projectId, handleProjectIdChange,
        projectMoney, handleProjectMoneyChange,
        external, handleChangeAuthor, handleChangeArticleType,
        staticArticleType, editCallback,
    } = useUpdatedDraft()
    const author = (dialogData.board as Board).author
    const creator = (dialogData.board as Board).creator_info
    const { roleMap } = useContext(AppContext)
    const { isTrueEditor, isOpEditor } = roleMap
    const { role } = creator
    const { role_name } = role
    const creatorIsUser = role_name === "side_editor"
    return (
        <Fragment>
            <BoardConfirmModal
                title="修改候选项"
                confirmCallback={callback}
                cancelCallback={cancelCallback}
                editCallback={editCallback}
                modalShow={dialogData.show}
                disabled={disabled}
            >
                <Grid item>
                    <TextField
                        label="内容"
                        value={text}
                        onChange={handleChange}
                        className={classes.input}
                    />
                </Grid>
                <Grid item>
                    <FormControl className={classes.input}>
                        <InputLabel >文章类型</InputLabel>
                        <FieldSelect
                            rowData={{
                                article_type_id: external.articleTypeId,
                            }}
                            staticValue={staticArticleType}
                            tableName="article_type"
                            onChange={handleChangeArticleType}
                            // 2026-03 文章类型=“说明” 仅编辑部主编可预约
                            whereQuery={`where: {hidden: {_eq: false}${!isTrueEditor ? ', name: {_neq: "说明"}' : ''}}`}
                        />
                    </FormControl>
                </Grid>
                {/*除编辑部主编和编辑部运营外的角色在预约微信点位时，不再需要填写“负责人”*/}
                {/*编辑部主编和编辑部运营对于点位运营预约的点位进行修改时，不再显示负责人*/}
                {(isTrueEditor || isOpEditor) && !creatorIsUser && (
                    <Grid item>
                        <FormControl className={classes.input}>
                            <InputLabel>负责人</InputLabel>
                            <ChargePerson
                                chargePerson={author ? author.name : ""}
                                handleChangeAuthor={handleChangeAuthor}
                            />
                        </FormControl>
                    </Grid>
                )}
                <Grid item>
                    <div className={classes.materialBtn}>
                        <Button color="primary" onClick={editCallback}>编辑物料</Button>
                    </div>
                </Grid>
                {
                    // 编辑时，用户为商务部成员且时自己的预约时，展示项目编号及金额
                    isBusiness && isMine ? (
                        <>
                            <Grid container direction="column" justify="center">
                                <TextField
                                    label="项目编号"
                                    value={projectId}
                                    onChange={handleProjectIdChange}
                                    error={!!(projectId && projectId.length > 50)}
                                    helperText={!!(projectId && projectId.length > 50) ? '最多50英文字符' : undefined}
                                />
                            </Grid>
                            <Grid container direction="column" justify="center">
                                <TextField
                                    label="项目金额"
                                    value={projectMoney}
                                    onChange={handleProjectMoneyChange}
                                    error={!!(projectMoney && projectMoney.length > 50)}
                                    helperText={!!(projectMoney && projectMoney.length > 50) ? '最多50英文字符' : undefined}
                                />
                            </Grid>
                        </>
                    ) : null
                }
            </BoardConfirmModal>
        </Fragment>
    )
}

export default DraftUpdate
